import React, { useEffect, useMemo } from "react";
import SalesInvoiceReportHeader from "./SalesInvoiceReportHeader/SalesInvoiceReportHeader";
import {
  getInvoiceColumns,
  getInvoiceColumnValue,
  getInvoicePrint,
} from "../../redux/actions/invoiceReport.action";
import { useDispatch, useSelector } from "react-redux";
import { ReadCookie } from "../../utils/readCookie";
import { useLocation } from "react-router-dom";
import Loader from "react-loader-spinner";
import "./SalesInvoiceReport.css";
import { Button, Card } from "antd";
import moment from "moment";
import { TabTitle } from "../../utils/GeneralFunction";
import { currencySymbol } from "../../utils/constants";
import SalesInvoiceReportFooter from "./SalesInoiceReportFooter/SalesInvoiceReportFooter";

const SalesInvoiceReport = () => {
  TabTitle("Sales-Invoice-Report")
  const dispatch = useDispatch();
  const menuId = ReadCookie("menuId");
  const token = ReadCookie("token");
  const { invoicePrint, invoiceColumns, invoiceColumnsValues } = useSelector(
    (state) => state
  );

  function useQuery() {
    const { search } = useLocation();
    return React.useMemo(() => new URLSearchParams(search), [search]);
  }

  let query = useQuery();
  let invoice_header_id = query.get("invoice_header_id");

  useEffect(() => {
    dispatch(getInvoicePrint(token, invoice_header_id));
    dispatch(getInvoiceColumnValue(token, invoice_header_id));
    dispatch(getInvoiceColumns(token, invoice_header_id));
  }, [dispatch, menuId, token]);

  const footerData = invoicePrint && invoicePrint?.payload?.data[0];

  let groupValues =
    invoiceColumnsValues &&
    invoiceColumnsValues?.payload?.data.reduce(function (r, a) {
      r[a.gender_category_id] = r[a.gender_category_id] || [];
      r[a.gender_category_id].push(a);
      return r;
    }, Object.create(null));
  const groupedColumnValue = groupValues && Object.values(groupValues);
  const myData = useMemo(() => {
    return (
      invoiceColumns &&
      invoiceColumns?.payload?.data.sort((a, b) => a.gender_category_id - b.gender_category_id).map((it, i) => {
        return {
          column: it,
          detail: groupedColumnValue && groupedColumnValue[i],
        };
      })
    );
  }, [groupedColumnValue, invoiceColumns]);

  const handlePrint = () => {
    const css = '@page { size: portrait; }';
    const style = document.createElement('style');
    style.innerHTML = css;
    document.head.appendChild(style);
    window.print();
    document.head.removeChild(style); // Clean up after print
  };

  return (
    <div>
      {invoiceColumnsValues?.loading ? (
        <div className="loaderDiv">
          <Loader type="Grid" color="#212121" height={40} width={40} />
        </div>
      ) : (
        <div className="__sale_invoice_report">
          <table width="100%" className="__wrapper">
            <thead>
              <tr>
                <td>
                  <SalesInvoiceReportHeader />
                  {/* <div className="__header_space" /> */}
                </td>
              </tr>
            </thead>
            <tbody>
              <tr className="no-print">
                <td>
                  {!invoicePrint.loading && (
                    <div style={{ display: 'flex', justifyContent: 'flex-end', marginBottom: '16px', marginRight: "20px" }}>
                      <Button type="primary" onClick={handlePrint}>
                        Print
                      </Button>
                    </div>
                  )}
                </td>
              </tr>
              <tr>
                <td>
                  <Body footerData={footerData} myData={myData} />
                  <SalesInvoiceReportFooter footerData={footerData} />
                </td>
              </tr>
            </tbody>
            <tfoot></tfoot>
          </table>
        </div>
      )}
    </div>
  );
};

export default SalesInvoiceReport;

const Body = ({ footerData, myData }) => {
  const isFactor = footerData?.factor_id === 1

  return (
    <div className={`__content ${isFactor ? "__h_500" : "__h_400"}`}>
      <div className="__list_items">
        {myData?.map((size, index) => {
          return (
            <table key={index} width="100%">
              <thead>
                <tr>
                  <th
                    style={{ width: "36px" }}
                  >
                    S.No
                  </th>
                  <th
                    style={{ width: "88px" }}
                  >
                    SKU #
                  </th>
                  <th
                    style={{ width: "80px" }}
                  >
                    Brand
                  </th>
                  <th
                    style={{ width: "240px" }}
                  >
                    Style/Desc
                    <span style={{ marginLeft: "5px" }}>
                      {size?.column?.gender_category_name}
                    </span>
                  </th>
                  <th className="__size_col">
                    {size?.column?.hq23 || ''}
                  </th>
                  <th className="__size_col">
                    {size?.column?.hq24 || ''}
                  </th>
                  <th className="__size_col">
                    {size?.column?.hq25 || ''}
                  </th>
                  <th className="__size_col">
                    {size?.column?.hq26 || ''}
                  </th>
                  <th className="__size_col">
                    {size?.column?.hq27 || ''}
                  </th>
                  <th className="__size_col">
                    {size?.column?.hq28 || ''}
                  </th>
                  <th className="__size_col">
                    {size?.column?.hq29 || ''}
                  </th>
                  <th className="__size_col">
                    {size?.column?.hq30 || ''}
                  </th>
                  <th className="__size_col">
                    {size?.column?.hq31 || ''}
                  </th>
                  <th className="__size_col">
                    {size?.column?.hq32 || ''}
                  </th>
                  <th className="__size_col">
                    {size?.column?.hq33 || ''}
                  </th>
                  <th className="__size_col">
                    {size?.column?.hq34 || ''}
                  </th>
                  <th className="__size_col">
                    {size?.column?.hq35 || ''}
                  </th>
                  <th className="__size_col">
                    {size?.column?.hq36 || ''}
                  </th>
                  <th className="__size_col">
                    {size?.column?.hq37 || ''}
                  </th>
                  <th className="__size_col">
                    {size?.column?.hq38 || ''}
                  </th>
                  <th style={{ width: "50px" }}
                  >
                    Quantity
                  </th>
                  <th style={{ width: "80px" }}
                  >
                    Rate
                  </th>
                  <th
                    style={{ width: "80px" }}
                  >
                    Amount
                  </th>
                </tr>
                {size.detail?.map((it, index) => {
                  return (
                    <tr key={index}>
                      <td>{index + 1}</td>
                      <td
                        style={{
                          marginLeft: "0",
                        }}
                      >
                        {it.item_code}
                      </td>
                      <td>
                        {it?.sku_brand_name}
                      </td>
                      <td>{it.description}</td>
                      <td className="__size_col">
                        {it?.q23 || ""}
                      </td>
                      <td className="__size_col">
                        {it?.q24 || ""}
                      </td>
                      <td className="__size_col">
                        {it?.q25 || ""}
                      </td>
                      <td className="__size_col">
                        {it?.q26 || ""}
                      </td>
                      <td className="__size_col">
                        {it?.q27 || ""}
                      </td>
                      <td className="__size_col">
                        {it?.q28 || ""}
                      </td>
                      <td className="__size_col">
                        {it?.q29 || ""}
                      </td>
                      <td className="__size_col">
                        {it?.q30 || ""}
                      </td>
                      <td className="__size_col">
                        {it?.q31 || ""}
                      </td>
                      <td className="__size_col">
                        {it?.q32 || ""}
                      </td>
                      <td className="__size_col">
                        {it?.q33 || ""}
                      </td>
                      <td className="__size_col">
                        {it?.q34 || ""}
                      </td>
                      <td className="__size_col">
                        {it?.q35 || ""}
                      </td>
                      <td className="__size_col">
                        {it?.q36 || ""}
                      </td>
                      <td className="__size_col">
                        {it?.q37 || ""}
                      </td>
                      <td className="__size_col">
                        {it?.q38 || ""}
                      </td>
                      <td>
                        {it?.item_quantity || ""}
                      </td>
                      <td>
                        {currencySymbol} {it?.rate || ""}
                      </td>
                      <td>{currencySymbol} {it?.amount || ""}</td>
                    </tr>
                  );
                })}
              </thead>
            </table>
          )
        })}
      </div>
      <div className="__summary_box">
        <table width="100%">
          <tbody>
            <tr>
              <td></td>
              <td width="250px">
                <table width="100%" className="__summary_box_table">
                  <tbody>
                    <tr>
                      <td width="70%">Total Quantity</td>
                      <td width="30%">{footerData?.sum_quantity}</td>
                    </tr>
                    <tr>
                      <td>Gross Total</td>
                      <td>{currencySymbol} {footerData?.sum_gross_amount}</td>
                    </tr>
                    <tr>
                      <td
                        colSpan={2}
                        style={{
                          width: "100px",
                          textAlign: "left",
                          paddingLeft: "10px",
                          fontSize: "12px",
                        }}
                      >
                        LESS
                      </td>
                    </tr>
                    <tr>
                      <td>Disc Amount</td>
                      <td>{currencySymbol} {footerData?.discount}</td>
                    </tr>
                    <tr>
                      <td
                        colSpan={4}
                        style={{
                          width: "100px",
                          textAlign: "left",
                          paddingLeft: "10px",
                          fontSize: "12px",
                        }}
                      >
                        ADD
                      </td>
                    </tr>
                    <tr>
                      <td>Sales Tax</td>
                      <td>{currencySymbol} {footerData?.tax_percent}</td>
                    </tr>
                    <tr>
                      <td>Freight</td>
                      <td>{currencySymbol} {Number(footerData?.shipping_cost || 0).toFixed(2)}</td>
                    </tr>
                    <tr>
                      <td>Surcharge Amount</td>
                      <td>{currencySymbol} {Number(footerData?.surcharge_amount || 0).toFixed(2)}</td>
                    </tr>
                    <tr>
                      <td>C. C. Charges</td>
                      <td></td>
                    </tr>
                    <tr>
                      <td>Net Amount</td>
                      <td>{currencySymbol} {footerData?.net_amount}</td>
                    </tr>
                  </tbody>
                </table>
              </td>
            </tr>
          </tbody>
        </table>
      </div>
    </div>
  )
}